import styled from "@emotion/styled";
import { fontAngkor, theme } from "@product/scmp-sdk";

import { setFullViewportWidthStyles } from "shared/lib/styles";

import { ContentItemPostiesTodaysRead } from "scmp-app/components/content/content-item-render/variants/posties-todays-read";
import { ImageWrapper } from "scmp-app/components/content/content-item-render/variants/posties-todays-read/styles";

import RainbowMobile from "./rainbow-mobile.svg?url";
import Rainbow from "./rainbow.svg?url";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  position: relative;

  padding-block: 58px 15.9px;

  background-color: #ffffff;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 75px 14px;
    padding-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 79px 27px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    padding-block-end: 48px;
  }
`;

export const Headline = styled.div`
  display: block;

  margin-block-end: 32px;

  color: #1b4191;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.72px;
  text-align: center;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 40px;
    margin-inline-end: 8px;

    font-size: 48px;
    line-height: 56px;
    letter-spacing: -1.32px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 56px;
    letter-spacing: -1.44px;
  }
`;

export const StyledContentItemPostiesTodaysRead = styled(ContentItemPostiesTodaysRead)`
  position: relative;

  ${ImageWrapper} {
    &::after {
      position: absolute;
      inset-block-start: 50%;
      inset-inline-start: 0;
      content: "";
      z-index: 0;

      inline-size: 100%;
      padding-block-start: 54%;

      background-image: url(${RainbowMobile});
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      transform: translateY(-50%);

      ${theme.breakpoints.up("largeDesktop")} {
        padding-block-start: 52.78%;

        background-image: url(${Rainbow});
      }
    }
  }
`;

export const Content = styled.div`
  inline-size: 100%;
`;
